//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
import { isoToTimestamp, formattedDate } from '../utils/index';
// import _ from 'lodash';
export default {
  name: 'SandBoxItem',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
    jurisdiction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
        sandbox_type: '',
        sandbox_tmpl_id: '',
        desc: '',
      },
      jsonData: {},
      showJson: false,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        if (this.row.id) {
          this.$request({
            url: this.$api.getSandboxTemplate,
            data: {
              id: Number(this.row.id),
            },
          })
            .then((res) => {
              this.form = res.data;
              this.jsonData = this.form.desensitize_rule;
            })
            .catch((err) => {
              console.log('%c Line:115 🌶 err', 'color:#ea7e5c', err);
              this.form = {
                name: '',
                sandbox_type: '',
                sandbox_tmpl_id: '',
                desc: '',
              };
              this.jsonData = this.form.desensitize_rule;
            });
        }
      }
    },
  },
  methods: {
    dealTime(time) {
      time;
      console.log('%c Line:123 🌮 time', 'color:#f5ce50', time, isoToTimestamp(time));
      return formattedDate(isoToTimestamp(time));
    },
    openJsonEdit() {
      this.showJson = true;
    },
    close() {
      this.$emit('close');
    },
    edit() {
      this.$emit('close');
      this.$emit('editSandBoxTemplate', this.row);
    },
  },
};
